<template>
    <div>
        <div id="createClassModal" class="modal">
            <div class="modal-contents">
                <span class="close" @click="modalClose()">&times;</span>
                <div class="update-course">
                    <div class="modal-heading">
                        <h1 class="main-heading" v-if="schedule">Schedule Online Class</h1>
                        <h1 class="main-heading" v-else>Start Online Class</h1>
                    </div>
                    <div class="update-cour invite-main">
                        <div class="row">
                            <div class="col-md-12">
                                <form id="create-online-class" @submit.prevent="((schedule) ? createClass($event) : startClass($event))">
                                    <div class="row">
                                        <div class="col-md-10 col-md-offset-1">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label">Course</label>
                                                        <select class="form-control field-req" id="course_name" name="course_id" @change="setSections($event)">
                                                            <option value="">Select Course</option>
                                                            <option v-for="cl in courses" v-bind:value="cl.assigned_college_enc_id">
                                                                {{cl.course_name}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6" v-if="sections.length">
                                                    <div class="form-group">
                                                        <label class="ep-input-label">Section</label>
                                                        <select class="form-control field-req" id="section" name="section_id">
                                                            <option value="">Select Section</option>
                                                            <option v-for="sc in sections" v-bind:value="sc.section_enc_id">{{sc.section_name}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label">Semester</label>
                                                        <select class="form-control field-req" id="semester" name="semester">
                                                            <option value="" selected>Select Semester</option>
                                                            <option value="1">1st Semester</option>
                                                            <option value="2">2nd Semester</option>
                                                            <option value="3">3rd Semester</option>
                                                            <option value="4">4th Semester</option>
                                                            <option value="5">5th Semester</option>
                                                            <option value="6">6th Semester</option>
                                                            <option value="7">7th Semester</option>
                                                            <option value="8">8th Semester</option>
                                                            <option value="9">9th Semester</option>
                                                            <option value="10">10th Semester</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="ep-input-label">Class Name</label>
                                                        <input type="text" class="form-control dash-input field-req" name="subject_name" placeholder="Enter Subject Name">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="schedule">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="ep-input-label">Date</label>
                                                        <div class='input-group date' data-provide="datepicker" id='datepicker'>
                                                            <input type='text' class="form-control" id="start_date" name="date"/>
                                                            <div class="input-group-addon">
                                                                <span class="glyphicon glyphicon-calendar"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="ep-input-label">Start Time</label>
                                                        <input type="time" id="start_time" name="start_time" class="form-control dash-input field-req"/>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="ep-input-label">End Time</label>
                                                        <input type="time" id="end_time" name="end_time" class="form-control dash-input field-req"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="error-msg" v-html="error"></p>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <div class="form-group">
                                            <button type="submit" class="ss-button" v-if="schedule">Create Class</button>
                                            <button type="submit" class="ss-button" v-else>Start Class</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import toastr from '../../public/js/toastr.js';
    import axios from 'axios';
    import firebase from 'firebase';
    import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

    export default {
        data() {
            return {
                start_time: '',
                courses: [],
                sections: [],
                error:"",
                valid: false,
                schedule:true,
                specialKey: 'BnE3860mWdnBEZMLXlwkdjw9A2K5DJ',
                db: firebase.database(),
            }
        },
        mounted() {
            var t = this;
            if (!document.getElementById('my-datepicker')) {
                var scriptTag = document.createElement("script");
                var link = document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/css/datepicker.css';
                scriptTag.src = "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/js/bootstrap-datepicker.js";
                scriptTag.id = "my-datepicker";
                document.getElementsByTagName('head')[0].appendChild(link);
                document.getElementsByTagName('head')[0].appendChild(scriptTag);
            }
            var url = t.$store.getters.getDomain;

            axios.post(`${url}api/v2/classes/get-courses`, "", {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.courses = response['data']['response']['courses'];
                } else {
                    toastr.error('Courses not found. Try again later', 'Oops!!');
                }
            }).catch(function (error) {

            });
            setTimeout(function () {
                $(function () {
                    var today = new Date();
                    $("#datepicker").datepicker({
                        autoclose: true,
                        todayHighlight: true,
                        startDate:'+0d',
                    }).datepicker('update', new Date());
                });
            }, 2000);
        },
        methods: {
            modalFor(f){
                if(f){
                    this.schedule = true;
                } else {
                    this.schedule = false;
                }
            },
            modalClose() {
                $('#createClassModal').modal('hide');
            },
            createClass() {
                var t = this;
                if (!t.validateForm()) {
                    return false;
                }
                var elements = document.getElementById('create-online-class').elements;
                var obj = {};
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    if(item.name != "") {
                        obj[item.name] = item.value;
                    }
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/classes/create-class`, {
                    data: obj,
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            toastr.success('Class Scheduled', 'Success');
                            $('#createClassModal').modal('hide');
                            document.getElementsByClassName('reload-main')[0].click();
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            startClass(){
                var t = this;
                if (!t.validateForm()) {
                    return false;
                }
                var elements = document.getElementById('create-online-class').elements;
                var obj = {};
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    if(item.name != "") {
                        obj[item.name] = item.value;
                    }
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/classes/save-live-class`, {
                    data: obj,
                }, {headers: requestHeaders()})
                    .then(res => {
                        if (res['data']['response']['status'] == 200) {
                            toastr.success('Please wait your class is starting', 'Success');
                            t.$parent.getToken(res['data']['response']['data'].class_date,res['data']['response']['data'].class_id,true);
                            $('#createClassModal').modal('hide');
                            var ref = t.db.ref(t.specialKey + '/classes/' + t.$store.getters.getUser['college_enc_id'] + '/' + t.uniqueId());
                            ref.set({
                                'course': obj.course_id,
                                'semester': obj.semester,
                            });
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            validateForm(){
                var x, y, z, i, t = this;
                t.valid = true;
                x = document.getElementById("create-online-class");
                y = x.querySelectorAll(".field-req");
                for (i = 0; i < y.length; i++) {
                    if (y[i].value == "") {
                        y[i].className += " invalid";
                        t.valid = false;
                        if (y[i].nextSibling == null) {
                            var node = document.createElement("P");
                            node.classList = "error-msg";
                            var textnode = document.createTextNode("This field is Required.");
                            node.appendChild(textnode);
                            y[i].parentElement.appendChild(node);
                        }
                    } else {
                        y[i].classList.remove('invalid');
                        if (y[i].nextSibling) {
                            y[i].nextSibling.remove();
                        }
                    }
                }
                if(t.schedule) {
                    var dateVal = document.getElementById('start_date').value;
                    if (dateVal == "") {
                        document.getElementById('start_date').classList += " invalid";
                        t.valid = false;
                    } else {
                        document.getElementById('start_date').classList.remove('invalid');
                    }
                    var startTime = document.getElementById('start_time').value;
                    var endTime = document.getElementById('end_time').value;
                    if (startTime >= endTime) {
                        t.valid = false;
                        t.error = "Start time must be less than End time.";
                    } else {
                        t.error = "";
                    }
                }
                return t.valid;
            },
            setSections(event) {
                var t = this;
                var element = event.currentTarget
                var val = element.value;
                for (var i = 0; i < t.courses.length; i++) {
                    if (t.courses[i].assigned_college_enc_id == val) {
                        if (t.courses[i].collegeSections.length) {
                            t.sections = t.courses[i].collegeSections;
                        } else {
                            t.sections = [];
                        }
                    }
                }
            },
            uniqueId() {
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < 15; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return this.$store.getters.getUser['user_id'] + result;
            },
        }
    }
</script>

<style scoped>
    #datepicker{
        clear: both;
    }
    #start_time, #end_time{
        padding:10px;
        height: 42px;
    }
    .modal-contents {
        overflow: hidden !important;
        position: relative;
        background-color: #fff;
        overflow-y: scroll !important;
    }

    .modal-heading {
        text-align: center;
        padding: 10px;
    }

    .invite-main {
        max-width: 700px;
        margin: 0 auto;
    }

    .ss-button {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 15px;
    }

    .ss-button:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }

    #create-online-class label, .float-left {
        float: left;
    }
</style>